import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  title: {
    textAlign: "center",
  },
  paper: {
    width: "100%",
    margin: "16px",
  },
  dialogActions: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    maxWidth: "300px",
    margin: "0 auto",
  },
  resultLegend: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.common.white,
  },
}));
